import React from 'react';
import { Typography, Button, Input, Modal, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import VideoUploader from '../../components/utils/VideoUploader';
import { useAuth } from '../../contexts/AppContext';
import { hasElevatedSessionAccess } from '../../utils/sessionPermissions';

const { Text } = Typography;

/**
 * AdvVideoTab —— 广告视频上传与管理组件（受控组件）
 * 由父组件控制状态与保存逻辑
 *
 * @param {object} formData - 包含广告基础信息（含 id, permissionLevel 等）
 * @param {string} token - JWT token
 * @param {function} onChange - 修改字段，如 onChange('videoName', 'xxx')
 */
const AdvVideoTab = ({ formData, token, onChange }) => {
  const { userInfo } = useAuth();
  const { id: advId, permissionLevel = 0, video, videoName = '' } = formData;
  const canManageVideos = hasElevatedSessionAccess(userInfo, permissionLevel);

  // 没有广告 ID，说明 info 没保存，提示用户
  if (!advId) {
    return (
      <div className="p-4 text-center text-orange-600">
        Please save the advertisement info in "Info Settings" tab before uploading video.
      </div>
    );
  }

  // 权限不足提示
  if (!canManageVideos) {
    return (
      <div className="p-4 text-center">
        <h2 className="text-lg font-semibold mb-4 text-red-600">Access Denied</h2>
        <Text type="secondary">
          Your current plan does not allow video uploads.
          <br />
          Please contact your administrator to upgrade your service.
        </Text>
      </div>
    );
  }

  // 删除视频行为
  const handleDelete = () => {
    Modal.confirm({
      title: 'Confirm Delete',
      content: 'Are you sure you want to delete this video?',
      okText: 'Yes, delete it',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => {
        onChange('video', '');
        onChange('videoName', '');
        message.success('Video removed');
      }
    });
  };

  return (
    <div className="space-y-6 p-4">
      <h2 className="text-lg font-semibold">Video Management</h2>

      {/* 视频已上传：展示预览与输入框 */}
      {video ? (
        <div className="space-y-4">
          <video
            src={video}
            controls
            className="w-full max-w-2xl rounded border"
            style={{ maxHeight: 360 }}
          />

          {/* 输入视频名称 */}
          <Input
            value={videoName}
            onChange={(e) => onChange('videoName', e.target.value)}
            placeholder="Enter video name"
            size="large"
            maxLength={100}
          />

          {/* 删除按钮 */}
          <Button danger icon={<DeleteOutlined />} onClick={handleDelete}>
            Remove Video
          </Button>
        </div>
      ) : (
        // 未上传：显示上传按钮
        <VideoUploader
          token={token}
          onUploaded={(url) => {
            onChange('video', url);
          }}
        />
      )}
    </div>
  );
};

export default AdvVideoTab;
